module.exports = __webpack_public_path__ + "static/media/case_study.3eaf6e76.svg";